<template>
    <div class="plan-box">
        <h6 class="text-primary">📋 Planificado</h6>
<p v-if="actividad.costo_estimado_usd !== undefined">
  <strong>Costo Estimado:</strong> {{ simbolo }}{{ actividad.costo_estimado_usd.toFixed(2) }}
</p>
<p v-else class="text-muted fst-italic">
  No existe planificación para esta tarea
</p>
    </div>
</template>

<script>
export default {
    props: {
        actividad: Object,
        simbolo: String
    }
}
</script>

<style scoped>
.plan-box {
    background-color: #e9f2ff;
    border-left: 5px solid #4e73df;
    padding: 0.75rem;
    border-radius: 5px;
    font-size: 0.9rem;
}
</style>
